module.exports = __webpack_public_path__ + "static/media/menuapp.0e8258aa.mp4";